<template>
  <div>
    <v-snackbar v-model="showAlert" :top="true" color="error">{{authError}}</v-snackbar>

    <v-form v-if="!isRegistrationSuccess">
      <v-card>
        <v-card-text>
          <v-layout wrap>
            <v-flex xs12>
              <v-text-field
                v-validate="'required'"
                data-vv-as="Meno a priezvisko (názov firmy)"
                :error-messages="errors.collect('firstName')"
                prepend-icon="person"
                name="firstName"
                label="Meno a priezvisko (názov firmy)"
                type="text"
                autocomplete="username"
                v-model="registration.name"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <v-text-field
                v-validate="'required|email'"
                data-vv-as="Prihlasovací email"
                :error-messages="errors.collect('regEmail')"
                prepend-icon="email"
                name="regEmail"
                label="Prihlasovací email"
                type="email"
                autocomplete="email"
                v-model="registration.email"
              ></v-text-field>
            </v-flex>

            <!-- <v-flex xs12>
              <location-searcher v-on:locations="updateLocation" />
            </v-flex> -->

            <v-flex xs12>
              <v-text-field
                v-validate="'required'"
                data-vv-as="Telefón"
                :error-messages="errors.collect('regPhone')"
                prepend-icon="phone"
                name="regPhone"
                label="Telefón"
                autocomplete="phone"
                type="text"
                v-model="registration.phoneNumber"
              ></v-text-field>
            </v-flex>

            <v-flex xs12 sm6>
              <v-text-field
                v-validate="{ required: true, regex: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(.*?).{6,}$/ }"
                data-vv-as="Heslo"
                :error-messages="errors.collect('regPassword')"
                prepend-icon="lock"
                name="regPassword"
                label="Heslo"
                type="password"
                autocomplete="new-password"
                v-model="registration.password"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm6>
              <v-text-field
                v-validate="{required: true, is: registration.password}"
                data-vv-as="Potvrdenie hesla"
                :error-messages="errors.collect('regConfirmPassword')"
                prepend-icon="lock"
                name="regConfirmPassword"
                label="Potvrdenie hesla"
                type="password"
                autocomplete="new-password"
                v-model="registration.confirmPassword"
              ></v-text-field>
            </v-flex>
            <v-flex xs12>
              <small>*Heslo musí mať minimálne 6 znakov. Musí obsahovať veľké/malé znaky, číslo.</small>
            </v-flex>
            <v-flex>
              <v-checkbox v-model="registration.gdpr">
                <template v-slot:label>
                  <div>
                    Súhlasím s
                    <v-tooltip bottom>
                      <template v-slot:activator="{ on }">
                        <a @click="redirectToGdpr" v-on="on">prehlásenim o ochrane osobných údajov.</a>
                      </template>
                      Ochrana osobných údajov
                    </v-tooltip>
                  </div>
                </template>
              </v-checkbox>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            :disabled="loading || !registration.gdpr"
            color="primary"
            @click.prevent="submit"
          >
            Registrovať
            <!-- <span slot="loader" class="custom-loader">
              <v-icon dark light>cached</v-icon>
            </span>-->
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>

    <v-card v-else>
      <v-card-text>
        <v-layout justify-center class="pa-4">
          <v-icon x-large color="success">thumb_up</v-icon>
        </v-layout>

        <v-alert :value="true" color="success" icon="check_circle" outline>
          <span>Reqistracia prebehla uspesne.</span>
        </v-alert>
        <v-alert :value="true" color="info" icon="info" outline>
          <span>
            Pre overenie vášho účtu prosím skontrolujte svoj email
            <i>{{registration.email}}</i> a potvrte registraciu.
          </span>
        </v-alert>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import LocationSearcher from "@/components/widgets/LocationSearcher";
import * as types from "@/store/types";
export default {
  components: {
    LocationSearcher
  },
  data() {
    return {
      showAlert: false,
      showAlertTimout: 3000,
      registration: {
        email: "",
        name: "",
        phoneNumber: "+421",
        address: {},
        password: "",
        confirmPassword: "",
        gdpr: false
      },
      isRegistrationSuccess: false,
      isLoading: false,
      loading: false
    };
  },
  // provide() {
  //   return { parentValidator: this.$validator };
  // },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    authStatus() {
      return this.$store.getters.authStatus;
    },
    authError() {
      return this.$store.getters.authError;
    }
  },
  methods: {
    updateLocation(data) {
      this.registration.address = data;
    },
    submit: function() {
      this.$validator.validate().then(result => {
        if (result) {
          this.loading = true;
          this.$store
            .dispatch(types.AUTH_REGISTRATION, this.registration)
            .then(() => {
              this.isRegistrationSuccess = true;
            })
            .catch(e => {
              console.error(e);
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    redirectToGdpr() {
      let routeData = this.$router.resolve({
        name: "Gdpr"
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>
<style>
</style>
